import { Box } from '@mui/material';
import { StreamAuditResults } from '../../components/audit/results/StreamAuditResults';
import { EditorView } from '../../fragment-editor/EditorView';
import { useStreamSettingsStore } from '../../stores/stream-screen-settings.store';
import { StreamMode } from '../../types';
import { SegmentsAudioCache } from './segments-cache/SegmentsAudioCache';

/**
 * Bottom panel component for audio mode that displays either the editor view
 * or audit results based on the current stream mode.
 */
export function AudioBottomPanel() {
  const mode = useStreamSettingsStore((state) => state.mode);

  return (
    <Box mt={4}>
      {mode === StreamMode.EDITOR ? (
        <>
          <SegmentsAudioCache />
          <EditorView />
        </>
      ) : (
        <StreamAuditResults />
      )}
    </Box>
  );
}
